<template>
  <arco-layout-sider
    :collapsed="collapsed"
    :width="layoutWidth"
    breakpoint="lg"
    collapsible
    hide-trigger
  >
    <div class="side_bar">
      <arco-menu
        v-model:collapsed="collapsed"
        :selected-keys="[$route.name]"
        :style="{ width: `${layoutWidth}px` }"
        :trigger-props="{ contentClass: 'route_pop' }"
        :tooltip-props="{ contentClass: 'side_bar_tool_pop' }"
      >
        <ProjectLogo :collapsed="collapsed" />
        <!-- <GlobalSearch :collapsed="collapsed" /> -->

        <RecursionMenu :collapsed="collapsed" :list="visibleRoutes" :count="routesCount" />
      </arco-menu>

      <arco-menu
        v-model:collapsed="collapsed"
        :selected-keys="[$route.meta?.appName]"
        :style="{ width: `${layoutWidth}px` }"
        :tooltip-props="{ contentClass: 'side_bar_tool_pop' }"
        show-collapse-button
      >
        <router-link v-for="(app, index) in visibleApps" :key="index" :to="app">
          <arco-menu-item :key="app.name">
            <template #icon>
              <IconFont :type="app.meta.icon" style="font-size: 16px;" />
            </template>
            <div class="menu_label">
              {{ app.meta?.title }}
            </div>
            <IconClose @click.stop.prevent="removeHistory(app)" />
          </arco-menu-item>
        </router-link>

        <AvatarSpecial :collapsed="collapsed" />
      </arco-menu>
    </div>
  </arco-layout-sider>
</template>

<script>
import { h } from 'vue'
import { mapState, mapActions } from 'pinia'
import { RouterLink, onBeforeRouteLeave } from 'vue-router'
import {
  SubMenu as ArcoSubMenu,
  MenuItem as ArcoMenuItem,
  Badge as ArcoBadge
} from '@arco-design/web-vue'
import SvgIcon from '@fe/zxwy-utils/components/v-svg-icon'
import websocketMixin from '@fe/zxwy-utils/mixins/v-websocket'
import { appConfig } from '@/tool/appConfig'
import { loginValidate } from '@/tool/permission'
import { useLayoutStore } from '@/store/modules/layout'
import { getNumberOfHotSpots } from '@/api/system'

import AvatarSpecial from './AvatarSpecial'
import ProjectLogo from './ProjectLogo'
import { usePermissionStore } from '@/store/modules/permission'
// import GlobalSearch from './GlobalSearch'
export default {
  name: 'SideBar',
  mixins: [websocketMixin],
  components: {
    RecursionMenu: {
      props: {
        level: { type: Number, default: 0 },
        collapsed: { type: Boolean, default: false },
        list: { type: Array, default: () => [] },
        count: { type: Object, default: () => ({}) }
      },
      render() {
        return this.list.map((item, index) => {
          if (item.children?.length === 1) item = item.children[0]
          if (item.children?.length > 1) {
            return h(ArcoSubMenu, { key: item.name }, {
              default: () => h(this.$options, {
                list: item.children,
                count: this.count,
                collapsed: this.collapsed,
                level: this.level + 1
              }),
              icon: () => h(ArcoBadge, {
                count: !this.collapsed || this.level !== 0 ? 0 : this.count[item.name] || 0,
                dot: true
              }, () => [
                h(SvgIcon, { type: item.meta?.icon || '' }),
                h(SvgIcon, { type: `${item.meta?.icon || ''}-active`, class: 'active' })
              ]),
              title: () => [
                h('div', { class: 'menu_label' }, item.meta?.title),
                h(ArcoBadge, { count: this.count[item.name] || 0, maxCount: 99 })
              ]
            })
          }
          return h(
            RouterLink,
            { key: index, to: { name: item.name }},
            {
              default: () => h(ArcoMenuItem, { key: item.name }, {
                icon: () => h(ArcoBadge, {
                  count: !this.collapsed || this.level !== 0 ? 0 : this.count[item.name] || 0,
                  dot: true
                }, () => [
                  h(SvgIcon, { type: item.meta?.icon || '' }),
                  h(SvgIcon, { type: `${item.meta?.icon || ''}-active`, class: 'active' })
                ]),
                default: () => [
                  h('div', { class: 'menu_label' }, item.meta?.title),
                  !this.count[item.name] ? '' : h(ArcoBadge, { count: this.count[item.name] || 0, maxCount: 99 })
                ]
              })
            }
          )
        })
      }
    },
    AvatarSpecial,
    ProjectLogo
    // GlobalSearch
  },
  data() {
    return {
      collapsed: this.$route.meta?.isApp || this.$route.meta?.collapsed,
      routesCount: {}
    }
  },
  computed: {
    ...mapState(useLayoutStore, ['layoutWidth', 'visibleRoutes', 'visibleApps'])
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler() {
        if (!this.$route.meta?.isApp) return
        this.addHistory(this.$route.meta?.appName, this.$route)
      }
    }
  },
  async mounted() {
    onBeforeRouteLeave((to, from) => {
      if (to.meta?.isApp !== from.meta?.isApp) {
        this.collapsed = to.meta?.isApp || to.meta?.collapsed
      } else if (to.meta?.collapsed !== from.meta?.collapsed) {
        this.collapsed = to.meta?.collapsed
      }
    })
    this.getNumberOfHotSpots()
    const { accessToken } = await loginValidate().catch(() => {
      usePermissionStore().logout()
    })

    await this.wsInit({
      url: `${appConfig.WS_BASE_API}/bpm/ws/global?token=${accessToken}`,
      watchMessage: (event) => {
        if (event.data.type === 'zxwy-global-refresh') return this.getNumberOfHotSpots()
      }
    })
  },
  methods: {
    ...mapActions(useLayoutStore, ['addHistory', 'removeHistory']),

    // 获取热点数量
    getNumberOfHotSpots() {
      getNumberOfHotSpots().then(res => {
        this.routesCount = {
          'ApprovalPage': res.data.approveCount,
          'MessagePage': res.data.messageCount
        }
      }).catch(err=>{
        console.log(err)
      })
    }
  }
}
</script>

<style lang='less' scoped>
.arco-layout-sider {
  box-shadow: none;
  // background-color: transparent;
  :deep(.arco-layout-sider-children) {
    overflow-x: hidden;
  }
}

.side_bar {
  height: 100%;
  display: flex;
  flex-direction: column;
  .arco-menu {
    background: transparent;

    &.arco-menu-collapsed :deep(.project_logo) { height: 40px; }
    &.arco-menu-collapsed :deep(.project_logo img) { width: 28px; height: 18px; }
    &.arco-menu-collapsed :deep(.arco-menu-item) { padding: 0 0px;margin: 0; }

    :deep(.arco-menu-inner) { padding-top: 0; padding-bottom: 0; }

    &:first-child {
      :deep(.arco-menu-icon) .svg-icon.active { display: none; }
      :deep(.arco-menu-item:hover) .svg-icon.active,
      :deep(.arco-menu-item.arco-menu-selected) .svg-icon.active,
      &.arco-menu-collapsed :deep(.arco-menu-pop-header:hover) .svg-icon.active,
      &.arco-menu-collapsed :deep(.arco-menu-pop-header.arco-menu-selected) .svg-icon.active { display: inline-block; }
      :deep(.arco-menu-item:hover) .svg-icon:not(.active),
      :deep(.arco-menu-item.arco-menu-selected) .svg-icon:not(.active),
      &.arco-menu-collapsed :deep(.arco-menu-pop-header:hover) .svg-icon:not(.active),
      &.arco-menu-collapsed :deep(.arco-menu-pop-header.arco-menu-selected) .svg-icon:not(.active) { display: none; }
    }
    &:last-child {
      flex: 1;
      border-top: 1px solid var(--color-neutral-3);
      padding-top: 12px;
      padding-bottom: 90px;
      overflow-y: auto;
      &.arco-menu-collapsed :deep(.avatar_special) { padding: 0 4px; }
      :deep(.avatar_special) { width: calc(100% - 8px); }
    }

    // 取消默认白色背景
    :deep(.arco-menu-item),
    :deep(.arco-menu-inline-header),
    :deep(.arco-menu-pop-header),
    :deep(.arco-menu-group-title) { background: transparent; }
    // 设置icon样式
    :deep(.arco-menu-icon) .svg-icon {
      height: 18px;
      width: 18px;
      stroke: initial;
    }
    :deep(.arco-menu-item){
      padding: 0;
      .arco-menu-icon{
        border-left: 3px solid transparent;
        padding-left:5px;
      }
    }
    // 设置激活样式
    :deep(.arco-menu-item.arco-menu-selected),
    :deep(.arco-menu-pop-header.arco-menu-selected) {
      color: rgba(78, 186, 88);
      // background: rgba(78, 186, 88, 0.1) !important;

        .arco-menu-icon{
          border-color: rgba(108, 195, 62, 1);
        }
      :deep(.arco-menu-title) .arco-icon-close { display: initial; }
    }
    // 设置默认样式
    :deep(.arco-menu-title) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      .menu_label {
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &:hover .arco-icon-close { display: initial; }
      .arco-icon-close {
        display: none;
        margin-right: 0;
        margin-left: 10px;
        color: var(--color-text-3) !important;
        border-radius: var(--border-radius-small);
        padding: 0.5em;
        height: 2em;
        width: 2em;
        &:hover { background-color: var(--color-fill-1) !important; }
      }
    }

    // :deep(.arco-menu-collapse-button) {
    //   box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    // }
  }
}
</style>

<style lang="less">
.route_pop {
  // 设置icon样式
  .svg-icon {
    height: 18px;
    width: 18px;
    stroke: initial;
  }
  .svg-icon.active { display: none; }
  .arco-trigger-menu-item:hover .svg-icon.active,
  .arco-trigger-menu-item.arco-trigger-menu-selected .svg-icon.active,
  .arco-trigger-menu-pop-header:hover .svg-icon.active,
  .arco-trigger-menu-pop-header.arco-trigger-menu-selected .svg-icon.active { display: inline-block; }
  .arco-trigger-menu-item:hover .svg-icon:not(.active),
  .arco-trigger-menu-item.arco-trigger-menu-selected .svg-icon:not(.active),
  .arco-trigger-menu-pop-header:hover .svg-icon:not(.active),
  .arco-trigger-menu-pop-header.arco-trigger-menu-selected .svg-icon:not(.active) { display: none; }
  // 设置激活样式
  .arco-trigger-menu-item.arco-trigger-menu-selected,
  .arco-trigger-menu-pop-header.arco-trigger-menu-selected {
    color: rgba(78, 186, 88);
    background: rgba(78, 186, 88, 0.1) !important;
    .arco-trigger-menu-title .arco-icon-close { display: initial; }
  }
  // 设置默认样式
  .arco-trigger-menu-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
  }
}
.side_bar_tool_pop {
  .arco-badge { display: none; }
  .arco-icon-close { display: none; }
}
</style>